import type { ICategory } from "web/types/Category";
import type { Nullable } from "web/types/Utils";

const getParentCategoryId = (
  startCategoryData: ICategory,
  rootCategoryId: number
): Nullable<number> => {
  const pathSplit = startCategoryData.path.split("/");
  const currentIdIndex = pathSplit.indexOf(`${startCategoryData.id}`);
  const parentId = currentIdIndex ? +pathSplit[currentIdIndex - 1] : null;

  return parentId && parentId !== rootCategoryId ? parentId : null;
};

export default getParentCategoryId;
